import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Icon from 'components/common/Icon/Icon'
import Button from 'components/common/Button/Button'

const PromoTeaser = ({
  className,
  children,
  disabled,
  asset,
  imgUrl,
  handlePromotionClick,
  promotionAsset,
  ...props
}) => (
  <Teaser data-at-compare-page-teaser className={ className } onClick={ handlePromotionClick } { ...props }>
    {
      promotionAsset &&
      <Icon asset={ promotionAsset } float="left" margin="0 0 0 -30px" alt="" />
    }
    {
      imgUrl &&
      <Image src={ imgUrl } alt="" />
    }
    <TeaserButton data-teaser-link link bolder>{ children }</TeaserButton>
  </Teaser>
)


PromoTeaser.propTypes = {
  asset: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  handlePromotionClick: PropTypes.func,
  imgUrl: PropTypes.string,
  promotionAsset: PropTypes.string,
  promotionId: PropTypes.string,
  showPromotionModal: PropTypes.func
}

export default PromoTeaser


const Teaser = styled.div`
  position: relative;
  padding: 0 0 3px 30px;
  color: ${Theme.colors.blue};
  ${Mixin.font.GothamBold(14)}

  & + & {
    margin-top: 15px;
  }

  ${props => props.light && css`
    ${Mixin.font.GothamBook()}
  `}
`

const Image = styled.img`
  float: left;
  width: 20px;
  margin: -2px 0 0 -30px;
`

const TeaserButton = styled(Button)`
  && {
    padding: 0;
    text-align: left;
  }
`
